export const forMd = `@media (min-width: 991.98px)`
export const forTablet = `@media (min-width: 700px)`
